import React from 'react'
import CIcon from '@coreui/icons-react'
import { cilAccountLogout, cilAddressBook, cilBasket, cilChartPie,  cilDescription,  cilFactory,  cilGroup,  cilHandshake, cilInbox, cilLoopCircular, cilPin, cilPuzzle, cilSettings, cilShareBoxed } from '@coreui/icons'
import { CNavGroup } from '@coreui/react'

const _nav = [
  {
    component: CNavGroup,
    name: 'شرکت',
    to: 'Company',
    icon: <CIcon icon={cilFactory} customClassName="nav-icon" height={25}/>,
  },
  {
    component: CNavGroup,
    name: 'مشتریان',
    to: 'Customers',
    icon: <CIcon icon={cilAddressBook} customClassName="nav-icon" height={25}/>,
  },
  {
    component: CNavGroup,
    name: 'کالاها/خدمات',
    to: 'Kala',
    icon: <CIcon icon={cilBasket} customClassName="nav-icon" height={25} />,
  },
  {
    component: CNavGroup,
    name: 'صورتحساب ها',
    to: 'Factor',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" height={25}/>,
  },
  {
    component: CNavGroup,
    name: 'کاربران',
    to: 'AccUser',
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" height={25}/>,
  }, 
  {
    component: CNavGroup,
    name: 'عملیات مالی',
    to: 'AccUserDeposit',
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" height={25}/>,
  }, 
  {
    component: CNavGroup,
    name: 'تنظیمات',
    to: 'Setting',
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" height={25}/>,
  },
  // {
  //   component: CNavGroup,
  //   name: 'تغییر کلمه عبور کاربران',
  //   to: 'ReSetPassUsers',
  //   icon: <CIcon icon={cilLoopCircular} customClassName="nav-icon" height={25}/>,
  // },
  // {
  //   component: CNavGroup,
  //   name: 'تغییر کلمه عبور',
  //   to: 'ChangePassword',
  //   icon: <CIcon icon={cilHandshake} customClassName="nav-icon" height={25}/>,

  // },
]
export default _nav
